import type { User } from '@auth0/auth0-spa-js';

import { ErrorBase } from './error-base';

type ForbiddenErrorReason =
  | 'NO_ORGANIZATIONS_FOUND'
  | 'ORGANIZATION_ACCESS_DENIED'
  | 'ACCESS_DENIED';

type ForbiddenErrorData = {
  reason: ForbiddenErrorReason;
  user?: User;
  showAction?: boolean;
};

/**
 * Used for application level core errors
 * eloc / rendall core calls
 */
export class ForbiddenError extends ErrorBase<ForbiddenErrorData> {
  constructor(data: ForbiddenErrorData) {
    super(403, 'Forbidden', data);
  }
}
